import React from "react";

const Genealogy: React.FC = () => {
  return <>GENEALOGY PAGE</>;
};

export default Genealogy;
